import React from "react";

interface Props {
  data: {
    replies: string[];
  };
  onSelect: (reply: string) => void;
}

export const QuickRepliesWidget: React.FC<Props> = ({ data, onSelect }) => {
  if (!data?.replies || data.replies.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {data.replies.map((reply, index) => (
        <button
          key={index}
          onClick={() => onSelect(reply)}
          className="px-4 py-2 text-sm rounded-full border-2 border-primary/30 text-foreground hover:bg-primary/10 hover:border-primary/50 transition-all"
        >
          {reply}
        </button>
      ))}
    </div>
  );
};
